import { ReactNode } from 'react';

import styled from 'styled-components';

interface Props {
  className?: string;
  color: string;
  textColor?: string;
  children: ReactNode;
}

const Base = styled.div`
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.text};
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  padding: 0 4px;
  white-space: pre;
  width: fit-content;
`;

export const Tag = (props: Props) => (
  <Base
    className={props.className}
    style={{ color: props.textColor, backgroundColor: props.color }}>
    {props.children}
  </Base>
);
